import React, {FC} from "react";
import {ModerationUser} from "interfaces";
import {getStyleForUserReviewTag, UserReviewTags} from "enums";
import Highlighter from "react-highlight-words";

interface Props {
    user: ModerationUser
}

export const ModerationName: FC<Props> = ({user}) => {
    const nameTags = [
        UserReviewTags.BannedName,
        UserReviewTags.HiddenName,
        UserReviewTags.NeedsVerificationName,
        UserReviewTags.SuspiciousName,
        UserReviewTags.ReviewRequiredName,
        UserReviewTags.ShadowBannedName,
    ];

    const currentNameTag = user.reviewTags.find(t => nameTags.includes(t.tag) && t.info?.split('name: ')?.[1] === user.name);
    const currentAbuseWord = currentNameTag?.info?.split(', ')?.[0]?.split('Abuse reason: ')?.[1];
    const style = currentNameTag ? getStyleForUserReviewTag(currentNameTag.tag) : null;
    const nameText = `${user.name}${user.age ? ', ' : ''}${user.age ?? ''}`;

    return <div className="d-flex flex-row align-items-center mb-1">
        {currentAbuseWord && style ?
            <Highlighter
                highlightStyle={{backgroundColor: style.style?.backgroundColor + '50'}}
                searchWords={[currentAbuseWord]}
                autoEscape={true}
                textToHighlight={nameText}
                className="h5 mb-0"
            />
            : <h5 className="mb-0">{nameText}</h5>
        }
        {currentNameTag && style && <div className="d-flex flex-row">
            <div className={`mx-2 badge ${style.bg} ${style.text} small`} style={style.style}>
                #{currentNameTag.tag}
            </div>
        </div>
        }
    </div>
}